import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import {
  BillingVisibility,
  FrontendPaidFeatureService,
} from '../../frontend-paid-feature.service';
import { PlansAlertData } from '@tablesready/frontend-plans';
import { AuthUser } from '@shared/signup/models';

@Component({
  selector: 'frontend-paid-feature-alert[user]',
  templateUrl: './frontend-paid-feature-alert.component.html',
  standalone: false,
})
export class FrontendPaidFeatureAlertComponent implements OnChanges {
  @Input() classes = '';
  @Input() visible = false;
  @Input() plansAlertData?: PlansAlertData;
  @Input() user?: AuthUser;
  @Input() featureName = 'The features on this page are ';

  mobileVisibility = this.service.billingsVisibility

  constructor(private service: FrontendPaidFeatureService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['user'] && this.user) {
      this.service.setUser(this.user);
    }
  }

  protected readonly BillingVisibility = BillingVisibility;
}
